import type { DoseStatus, DueItem, Mother, ProtocolStep } from '../types';
import { addDays, dayDiff, parseDate, startOfToday, statusByDiff, toIsoDate } from '../lib/dates';
import { defaultProtocol, milestoneMarks } from './mockData';
import { realStatus, type ClinicData } from './store';

// Visits dated before the mother joined the clinic are shown as "Before joining" and never tracked.
export function trackedSince(m: Mother): string {
  return m.consent.date;
}

export interface MilestoneSource {
  protocol: ProtocolStep[];
  marks: Record<string, DoseStatus>;
  real: boolean;
}

export const sourceOf = (c: ClinicData): MilestoneSource => ({ protocol: c.protocol, marks: c.milestoneMarks, real: c.real });

const demoSource: MilestoneSource = { protocol: defaultProtocol, marks: milestoneMarks, real: false };

export function milestoneItems(m: Mother, includeBefore = false, src: MilestoneSource = demoSource): DueItem[] {
  const lmp = m.lmp;
  if (m.stage !== 'pregnancy' || !lmp) return [];
  const today = startOfToday();
  const since = trackedSince(m);
  return src.protocol
    .filter((p) => p.stage === 'pregnancy')
    .map((p): DueItem => {
      const date = addDays(parseDate(lmp), (p.pregnancyWeek ?? 0) * 7);
      const id = `${m.id}-${p.id}`;
      const iso = toIsoDate(date);
      const status = src.real ? realStatus(src.marks[id], iso) : src.marks[id] ?? statusByDiff(dayDiff(today, date));
      return { id, kind: 'milestone', mother: m, name: p.name, date: iso, status };
    })
    .filter((i) => includeBefore || i.date >= since);
}
